import { Helmet } from "react-helmet-async";

const HelemtHead = ({ title, name, desc }) => {
    return (
        <Helmet>
            <title>{title}</title>
            <meta name={name} content={desc} />
        </Helmet>
    )
}
export default HelemtHead;